import { Box, CircularProgress, Typography } from '@mui/material';
import { AlarmItem } from './AlarmItem';
import { HubsNames, useSignalRHubStore } from '../../stores/useSignalR';
import { DateTime } from 'luxon';
import { NoAlarms } from '../Icons/NoAlarms';
import { useMessageStore } from '../../stores/useMessageStore';
import { convertFiltersToQuery } from '../../utils/convertFiltersToQuery';
import { useEffect } from 'react';
import { IExtendedFiltersValues } from '../../stores/useFilters';

interface AlarmsProps {
  filtersValues: IExtendedFiltersValues | null;
}

export const Alarms = ({ filtersValues }: AlarmsProps) => {
  const setStreamArgs = useSignalRHubStore((state) => state.setStreamArgs);
  const disposeStream = useSignalRHubStore((state) => state.disposeStream);

  useEffect(() => {   
    if (!filtersValues) return;
    const query = convertFiltersToQuery(filtersValues);
    if (query) {
      setStreamArgs(HubsNames.alarmsSummary, query);
    }

    return () => {
      disposeStream(HubsNames.alarmsSummary);
    };
  }, [filtersValues, setStreamArgs, disposeStream]);
  
  const { messages = [], loading = true } = useMessageStore((state) => {
    return {
      messages: state.messages[HubsNames.alarmsSummary],
      loading: state.stableLoadingFlags[HubsNames.alarmsSummary],
    };
  });

  const alarms = [...messages]
    .sort((a, b) => b.incidentPeriod?.start?.ticks - a.incidentPeriod?.start?.ticks)
    .map((item) => {
      return {
        key: item.alertId,
        id: item.alertId,
        name: item.name,
        description: item?.bargeInfo?.name,
        timestamp: DateTime.fromISO(item?.incidentPeriod?.start?.date).toFormat('yyyy-LL-dd HH:mm'),
      };
    });

  const loaderBlock = (
    <Box sx={{ display: 'flex', justifyContent: 'center', padding: '0.5em' }}>
      <CircularProgress />
    </Box>
  );

  const noDataBlock = (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1em' }}>
      <NoAlarms />
      <Typography>No alarms</Typography>
    </Box>
  );

  return (
    <Box>
      {loading ? (
        loaderBlock
      ) : messages.length === 0 ? (
        noDataBlock
      ) : (
        <Box sx={{ maxHeight: '400px', overflowY: 'scroll' }}>
          {alarms.map((alarm: any) => (
            <AlarmItem key={alarm.key} {...alarm} />
          ))}
        </Box>
      )}
    </Box>
  );
};
